import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServiceDetailPage.css';

const RRHHPage = () => {
  const subServices = [
    {
      title: 'Reclutamiento y Selección',
      description: 'Identificamos y seleccionamos el talento ideal para su organización.',
      features: [
        'Análisis de perfiles y competencias',
        'Búsqueda activa de candidatos',
        'Evaluaciones psicotécnicas',
        'Entrevistas por competencias',
        'Verificación de referencias'
      ]
    },
    {
      title: 'Administración de Personal',
      description: 'Gestión integral de todos los procesos administrativos del personal.',
      features: [
        'Gestión de planillas',
        'Control de asistencia',
        'Liquidaciones y beneficios sociales',
        'Trámites ante entidades',
        'Archivo y documentación'
      ]
    },
    {
      title: 'Capacitación y Desarrollo',
      description: 'Programas de formación para potenciar el talento de su equipo.',
      features: [
        'Diagnóstico de necesidades',
        'Diseño de programas de capacitación',
        'Talleres y seminarios',
        'Evaluación de desempeño',
        'Planes de desarrollo profesional'
      ]
    },
    {
      title: 'Outsourcing de Personal',
      description: 'Provisión de personal calificado bajo modalidad de tercerización.',
      features: [
        'Personal operativo',
        'Personal administrativo',
        'Personal especializado',
        'Gestión laboral completa',
        'Reemplazo garantizado'
      ]
    },
    {
      title: 'Consultoría en RRHH',
      description: 'Asesoría especializada para optimizar su gestión de capital humano.',
      features: [
        'Diseño organizacional',
        'Evaluación de clima laboral',
        'Sistemas de compensaciones',
        'Políticas y procedimientos',
        'Cumplimiento normativo'
      ]
    },
    {
      title: 'Gestión del Talento',
      description: 'Estrategias para atraer, retener y desarrollar a los mejores profesionales.',
      features: [
        'Programas de atracción de talento',
        'Planes de carrera',
        'Gestión por competencias',
        'Retención de personal clave',
        'Cultura organizacional'
      ]
    }
  ];

  return (
    <div className="service-detail-page">
      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Recursos Humanos</h1>
          <p>Gestión integral del capital humano para el éxito de su organización</p>
        </div>
      </section>

      <section className="service-intro">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>Su Socio Estratégico en Gestión Humana</h2>
              <p>
                Nuestros servicios de Recursos Humanos están diseñados para ayudarle a construir 
                equipos de alto desempeño, optimizar procesos administrativos y crear una cultura 
                organizacional sólida.
              </p>
              <p>
                Con amplia experiencia en diferentes sectores, ofrecemos soluciones integrales que 
                van desde la selección de personal hasta la gestión estratégica del talento.
              </p>
            </div>
            <div className="intro-image">
              <img 
                src="/images/rrhh-principal.jpg" 
                alt="Recursos Humanos"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 400"%3E%3Crect fill="%230D3B66" width="500" height="400"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="white" font-size="80"%3E💼%3C/text%3E%3C/svg%3E';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="sub-services">
        <div className="container">
          <h2>Nuestros Servicios de RRHH</h2>
          <div className="sub-services-grid">
            {subServices.map((service, index) => (
              <div key={index} className="sub-service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul>
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-benefits">
        <div className="container">
          <h2>Ventajas de Nuestros Servicios de RRHH</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">🎯</div>
              <h3>Experiencia Sectorial</h3>
              <p>Conocimiento profundo de diversos sectores</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">⚖️</div>
              <h3>Cumplimiento Legal</h3>
              <p>Actualización constante normativa</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">💡</div>
              <h3>Soluciones Innovadoras</h3>
              <p>Metodologías modernas de gestión</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🤝</div>
              <h3>Aliado Estratégico</h3>
              <p>Compromiso con su éxito organizacional</p>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta">
        <div className="container">
          <h2>¿Necesita fortalecer su gestión de RRHH?</h2>
          <p>Conversemos sobre cómo podemos ayudarle a potenciar su capital humano</p>
          <div className="cta-buttons">
            <Link to="/contacto" className="btn-primary">Solicitar Cotización</Link>
            <Link to="/servicios" className="btn-secondary">Ver Todos los Servicios</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RRHHPage;
